<template>
  <div class="top-bar py-2 bg-green-dark text-light">
    <div class="container d-flex justify-content-between align-items-center">
      <!-- Alamat -->
      <div class="address">
        <i class="bi bi-geo-alt-fill me-2"></i>
        {{ infoDetail.alamat }}
      </div>

      <!-- Ikon Media Sosial -->
      <div class="social-icons">
        <a :href="infoDetail.fb" class="text-light me-3" target="_blank"> <i class="bi bi-facebook"></i> </a>
        <a :href="infoDetail.twitter" class="text-light me-3" target="_blank"> <i class="bi bi-twitter"></i> </a>
        <a :href="infoDetail.ig" class="text-light me-3" target="_blank"> <i class="bi bi-instagram"></i> </a>
        <a :href="`https://wa.me/`+infoDetail.wa" class="text-light me-3" target="_blank"> <i class="bi bi-whatsapp"></i> </a>
       
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "TopBar",
  data() {
    return {
      infoDetail: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchInfo() {
      try {
        const response = await axios.get(
          `https://mui-kendal.or.id/pengurus/Api/generalinfo`
        );
        this.infoDetail = response.data[0];
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchInfo();
  },
};
</script>

<style scoped>
.top-bar {
  background-color: #3ce764; /* Ganti dengan warna yang diinginkan */
  font-size: 1rem;
  color: #fff;
  font-size: 0.9rem;
}
.social-icons a {
  font-size: 1.2rem;
  transition: color 0.3s;
}
.social-icons a:hover {
  color: #0d6efd; /* Bootstrap primary color */
}
</style>
